import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.purchaseOrders.PurchaseOrderHelperFunctions.';
  public static readonly draft = `${Id.prefix}draft`;
  public static readonly purchaseOrderAbbrev = `${Id.prefix}purchaseOrderAbbrev`;
}

export class LangPurchaseOrderHelperFunctions {
  private constructor() {}
  public static draft(): string {
    return interpolate(Id.draft);
  }
  public static purchaseOrderAbbrev(params: { purchaseOrderNumber: string }): string {
    return interpolate(Id.purchaseOrderAbbrev, params);
  }
}

export class PurchaseOrderHelperFunctionsModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.draft, 'Draft', 'Label for draft purchase order');
    register.add(
      Id.purchaseOrderAbbrev,
      "{{glossary 'purchase-order-abbrev'}}: {{purchaseOrderNumber}}",
      'Abbreviated purchase order label with number'
    );
  }
}
